enum SeoRobots {
  NOINDEX_NOFOLLOW = 'noindex, nofollow',
}

/** @public */
type SeoMessage = {
  key: string;
  params?: Readonly<Record<string, number | string>>;
};

type SeoDescriptor = {
  description: SeoMessage;
  robots: SeoRobots;
  title: SeoMessage;
};

type SeoOverride = Partial<SeoDescriptor>;
/** @public */
type TitleNotification = { title: SeoMessage };

export { SeoRobots, type SeoDescriptor, type SeoMessage, type SeoOverride, type TitleNotification };
